import { FC } from 'react';
import RegistrationField from '../RegistrationField';
import ErrorView from '../form/inputs/ErrorView';

interface IErrorFields {
    errorFields: string[];
}

export const ErrorFields: FC<IErrorFields> = ({ errorFields }) => {
    return (
        <>
            {errorFields.map((errorField) => (
                <RegistrationField
                    key={errorField}
                    propertyPath={errorField}
                    component={ErrorView}
                    view="Alerts"
                />
            ))}
        </>
    );
};